import { z } from 'zod'

import { UpdateWebPushConsentSchema } from './UpdateWebPushConsentSchema'

export const userConsentSchemas = {
  updateWebPushConsent: {
    query: z.undefined(),
    path: z.undefined(),
    request: UpdateWebPushConsentSchema,
    response: z.undefined(),
  },
}
